import {
  memo,
  useEffect,
  useRef,
  useState,
} from "react";

import { AnalyticsEvent } from "@repo/edtech-analytics";
import { EdtechContentClient } from "@repo/edtech-content-client";

import { getParsedJson } from "../../../../lib";
import { Lesson, TrackFn } from "../../../../model";

import st from "./Longread.module.scss";

interface Props {
  lesson: Lesson,
  onFinishLesson: TrackFn,
}

export const Longread3 = memo(({
  lesson,
  onFinishLesson,
}: Props) => {
  const parsedJson = getParsedJson(lesson.richcontentJson);

  const endRef = useRef<HTMLDivElement | null>(null);
  const [ isCompleted, setIsCompleted ] = useState(false);

  useEffect(() => {
    if (!endRef.current || isCompleted) return;

    const observer = new IntersectionObserver(([ entry ]) => {
      if (entry?.isIntersecting) {
        setIsCompleted(true);
        onFinishLesson(
          { type: AnalyticsEvent.Completed },
          true,
          true,
        );

        observer.disconnect();
      }
    },
    {
      threshold: 1,
    });

    observer.observe(endRef.current);

    return () => observer.disconnect();
  }, [ onFinishLesson, isCompleted ]);

  return (
    <div className={st.wrap}>
      {
        parsedJson?.error ? (
          <div className={st.error}>
            Ошибка загрузки материала. Обратитесь в поддержку
          </div>
        ) : (
          <EdtechContentClient
            content={parsedJson}
          />
        )
      }
      <div ref={endRef} />
    </div>
  );
});

Longread3.displayName = "Longread3";
